<template>
    <app-layout>

        <Head>
            <title>Prozesse</title>
        </Head>

        <template v-slot:overline>
            <translate>Prozesse</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <div class="abilities">
            <div class="row">
                <div class="col col-3">
                    <card>
                        <card-header>
                            <card-overline>
                                <translate>Fertigungskapazitäten</translate>
                            </card-overline>
                        </card-header>
                        <card-content>
                            <p><translate>Nur Anfragen mit Stückzahlen im Bereich:</translate></p>
                            <form-group>
                                <form-input id="min_amount" :label="this.$gettext('von')" class="one-half" v-model="form.min_amount" :error="form.errors.min_amount" />
                                <form-input id="max_amount" :label="this.$gettext('bis')" class="one-half" v-model="form.max_amount" :error="form.errors.max_amount" />
                            </form-group>
                            <hr>
                            <p><translate>Ausgelastet / Betriebsferien. Keine Anfragen im Zeitraum:</translate></p>
                                <form-datepicker id="no_requests_from" :label="this.$gettext('von')" v-model:date="form.no_requests_from" :error="form.errors.no_requests_from" allow-holidays="true" allow-weekends="true" />
                                <form-datepicker id="no_requests_till" :label="this.$gettext('bis')" v-model:date="form.no_requests_till" :error="form.errors.no_requests_till" allow-holidays="true" allow-weekends="true" />
                        </card-content>
                    </card>
                </div>
                <div class="col">
                    <form @submit.prevent="submit">
                        <div class="row">
                            <div class="col">
                                <producer-abilities :producerUser="producerUser" :abilities="abilities" v-model="form.abilities"/>
                            </div>
                        </div>
                        <div class="row row--sticky" v-sticky>
                            <div class="col">
                                <form-actions>
                                    <form-button color="secondary" class="btn--block"><translate>Speichern</translate></form-button>
                                </form-actions>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import ProducerAbilities from '@partfactory/Shared/Producer/ProducerAbilities';
import {useForm} from '@inertiajs/vue3';
import FormActions from '@partfactory/Shared/Form/FormActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import FormInput from '@partfactory/Shared/Form/FormInput';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';
import FormGroup from '@partfactory/Shared/Form/FormGroup';

export default {
    name: 'Abilities',
    components: {
        FormGroup,
        FormDatepicker,
        CardContent,
        FormInput,
        CardHeader, Card, CardOverline, FormButton, FormActions, ProducerAbilities, AppLayout},
    props: {
        'producerUser': Object,
        'abilities': Object,
    },
    data() {
        const form = useForm({
            'abilities': this?.producerUser?.abilities,
            'min_amount': this?.producerUser?.min_amount,
            'max_amount': this?.producerUser?.max_amount,
            'no_requests_from': this?.producerUser?.no_requests_from,
            'no_requests_till': this?.producerUser?.no_requests_till,
        });

        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .patch(this.$$route('abilities.update'));
        },
    },
};
</script>
